

const menuHelper = {
    makeRegularMenu: makeRegularMenu,
    makeSideMenu: makeSideMenu,
    getNavigations: getNavigations
}

const adminMainMenu = [
    {
        label: 'HOME',
        to: '/',
        ficon: ['pi', 'pi-home'],
    },
    
    {
        ficon: ['pi', 'pi-bell'],
        bounceVar: 'unreadOperationsMessages',
        label: 'NOTIFICATIONS',
        to: "/notifications"
    },
    
    {
        ficon: ['pi', 'pi-comments'],
        bounceVar: 'unreadChatsMessages',
        label: 'MESSAGES_MENU',
        to: "/messages"
    },
    
    {
        label: 'BOOKS',
        to: '/books',
        ficon: ['pi', 'pi-book'],
    },
    
    {
        ficon: ['pi', 'pi-cog'],
        label: 'PROFILE_MENU',
        to: "/profile"
    },

    
    {
        label: 'USER_JOIN_REQUESTS',
        to: '/user_join_requests',
        ficon: ['pi', 'pi-user'],
    },
    {
        ficon: ['pi', 'pi-upload'],
        label: 'UPLOAD_BOOKS',
        to: "/import_books"
    },
    {
        label: 'COVER_CORRECTION',
        to: '/covers',
        ficon: ['pi', 'pi-wallet'],
    },
    {
        label: 'REWARDS',
        to: '/rewards',
        ficon: ['pi', 'pi-wallet'],
    }
]

const userMainMenu = [
    {
        label: 'HOME',
        to: '/',
        ficon: ['pi', 'pi-home'],
    },
    
    {
        ficon: ['pi', 'pi-bell'],
        bounceVar: 'unreadOperationsMessages',
        label: 'NOTIFICATIONS',
        to: "/notifications"
    },
    
    {
        ficon: ['pi', 'pi-comments'],
        bounceVar: 'unreadChatsMessages',
        label: 'MESSAGES_MENU',
        to: "/messages"
    },
  
    {
        label: 'MY_BOOKS',
        to: '/my_books',
        ficon: ['pi', 'pi-book'],
    },
   
    {
        label: 'OPERATIONS',
        to: '/operations',
        ficon: ['pi', 'pi-calculator']
    },
    
    {
        ficon: ['pi', 'pi-upload'],
        label: 'UPLOAD_BOOKS',
        to: "/upload_books"
    },

    {
        label: 'BORROW',
        ficon: ['pi', 'pi-file-import'],
        to: '/borrowing_request'
    },

    {
        label: 'GIFT',
        ficon: ['pi', 'pi-gift'],
        to: '/gift_request'
    },
    {
        label: 'EXCHANGE',
        ficon: ['pi', 'pi-sync'],
        to: '/exchange_request'
    },

    {
        ficon: ['pi', 'pi-cog'],
        label: 'PROFILE_MENU',
        to: "/profile"
    }
   
]

const adminProfileMenu = [
    /* {
        ficon: ['fas', 'user-gear'],
        label: 'PROFILE_MENU',
        to: "/profile"
    },
    {
        ficon: ['fas', 'bell'],
        bounceVar: 'unreadOperationsMessages',
        label: 'NOTIFICATIONS',
        to: "/notifications"
    },

    {
        ficon: ['fas', 'envelope'],
        bounceVar: 'unreadChatsMessages',
        label: 'MESSAGES_MENU',
        to: "/messages"
    } */


]

const userProfileMenu = [
   
/*     {
        ficon: ['fas', 'envelope'],
        bounceVar: 'unreadChatsMessages',
        label: 'MESSAGES_MENU',
        to: "/messages"
    },

    {
        ficon: ['fas', 'bell'],
        bounceVar: 'unreadOperationsMessages',
        label: 'NOTIFICATIONS',
        to: "/notifications"
    },

    {
        ficon: ['fas', 'user-gear'],
        label: 'PROFILE_MENU',
        to: "/profile"
    } */

]

function makeRegularMenu(isAdmin) {
    const menu = []
    if (isAdmin) {
        menu.push(adminMainMenu)
        menu.push(adminProfileMenu)
    } else {
        menu.push(userMainMenu)
        menu.push(userProfileMenu)
    }
    return menu
}

function makeSideMenu(isAdmin) {
    const menu = []
    if (isAdmin) {
        menu.push(adminMainMenu[0])
        adminProfileMenu.forEach(e => menu.push(e))
        adminMainMenu.slice(1).forEach(e => menu.push(e))
    } else {
        menu.push(userMainMenu[0])
        userProfileMenu.forEach(e => menu.push(e))
        userMainMenu.slice(1).forEach(e => menu.push(e))
    }
    return menu
}
function getNavigations(isAdmin) {
    if (isAdmin) {
        return adminMainMenu.map(e => e.to).concat(adminProfileMenu.map(e => e.to))
    } else {
        return userMainMenu.map(e => e.to).concat(userProfileMenu.map(e => e.to))
    }
}

export default menuHelper